import { render, staticRenderFns } from "./TeklifList.vue?vue&type=template&id=1307c13b"
import script from "./TeklifList.vue?vue&type=script&lang=js"
export * from "./TeklifList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports